export enum REPORT_TYPE {
  POST = "post",
  COMMENT = "comment",
  PROFILE = "profile",
  FEEDBACK = "feedback",
}

export enum REPORT_STATUS {
  PENDING = "pending",
  RESOLVED = "resolved",
  REJECTED = "rejected",
}

export enum REPORT_REASON {
  SPAM = "spam",
  HARASSMENT = "harassment",
  HATE_SPEECH = "hate_speech",
  NUDITY = "nudity",
  VIOLENCE = "violence",
  MISINFORMATION = "misinformation",
  SCAM = "scam",
  ILLEGAL = "illegal",
  SELF_HARM = "self_harm",
}

export enum REPORT_ACTION_TAKEN {
  NONE = "none",
  HIDDEN = "hidden",
  DELETED = "deleted",
}
